import React from 'react';
import { Modal, Button, Form, Tag } from 'antd';
import { REGISTRADO, EMITIDO, RECHAZADO, ANULADO } from '../../../common/types/comprobanteEstadoType';

export default class CdrModal extends React.Component {
     renderColor = (row) => {
        if (row.idResumenEstado === REGISTRADO)
            return 'blue';
        if (row.idResumenEstado === EMITIDO)
            return 'green';
        if (row.idResumenEstado === RECHAZADO)
            return 'orange';
        if (row.idResumenEstado === ANULADO)
            return 'red';
    };

    item = (label, value) => {
        return (
            <div style={{ width: '100%', display: 'inline-flex', marginBottom: 8, background: '#fafafa' }}>
                <div style={{ width: '170px', color: '#242424', padding: 6 }}>
                    {label}
                </div>
                <div style={{ width: 'calc(100% - 170px)', padding: 6 }}>
                    {value}
                </div>
            </div>
        );
    }

    render() {
        return (
            <Modal
                title={"CDR Sunat"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={550}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cancelar
                    </Button>,
                    <Button
                        key="2"
                        type="primary"
                        onClick={this.props.onDownloadXml}
                    >
                        Descargar XML
                    </Button>,
                    <Button
                        key="3"
                        type="primary"
                        onClick={this.props.onDownloadCdr}
                    >
                        Descargar CDR
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            {this.item("Tipo de Comprobante:", ' Resumen Diario')}
                            {this.item("Número de Documento:", this.props.item.correlativo)}
                            {this.item("Fecha de Envio:", this.props.item.fechaStr)}
                            {this.item("Fecha de Respuesta:", this.props.item.fechaEnvioStr)}
                            {this.item("Estado:",
                                <div className="custom-options" >
                                    <Tag color={this.renderColor(this.props.item)}>{this.props.item.nombreEstado}</Tag>
                                </div>)}
                            {this.item("Respuesta Sunat:", this.props.item.mensajeSunat)}
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}